<script setup lang="ts">
import Content from "@/components/Content.vue";
import Divider from "@/components/Divider.vue";
import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import Heading from "@/components/Heading.vue";

document.title = 'TSG R&D Retreat 2025 &bullet; tsgroup.space'
</script>

<template>
  <Title subtitle="Berlin, Germany">TSG R&D Retreat 2025</Title>

  <Divider/>

  <Content>
    Soon ...
  </Content>
</template>
